import React, { useEffect, useState } from "react";
import { createThread, getEmployees } from "../../../api/serviceRecordApi";
import { useNavigate } from "react-router-dom";

const CreateThread = () => {
    const navigate = useNavigate();

    const [employees, setEmployees] = useState([]);
    const [employeeId, setEmployeeId] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [authorizedBy, setAuthorizedBy] = useState("");
    const [attachment, setAttachment] = useState(null);

    useEffect(() => {
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        const res = await getEmployees();
        setEmployees(res.data.data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append("employeeId", employeeId);
        formData.append("subject", subject);
        formData.append("message", message);
        formData.append("authorizedBy", authorizedBy);

        if (attachment) {
            formData.append("attachment", attachment);
        }

        const res = await createThread(formData);

        if (res.data.success) {
            navigate(`/service-record`);
        }
    };

    return (
        <div className="container-fluid admin-module-page admin-service-record-page py-4">
            <div className="admin-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
                <div>
                    <span className="admin-page-kicker">Service Record</span>
                    <h3 className="admin-page-title fw-bold mb-1">Create Service Record</h3>
                    <p className="admin-page-description mb-0">
                        Start a new thread with a concise subject, message, and optional attachment.
                    </p>
                </div>

                <button
                    className="btn btn-outline-secondary admin-page-action"
                    onClick={() => navigate("/service-record")}
                >
                    Back to List
                </button>
            </div>

            <div className="card admin-surface-card">
                <div className="card-body admin-surface-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Employee</label>
                                <select
                                    className="form-select"
                                    value={employeeId}
                                    onChange={(e) => setEmployeeId(e.target.value)}
                                    required
                                >
                                    <option value="">-- Select Employee --</option>
                                    {employees.map(emp => (
                                        <option key={emp.intUserId} value={emp.intUserId}>
                                            {emp.vchFullName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Authorized By</label>
                                <select
                                    className="form-select"
                                    value={authorizedBy}
                                    onChange={(e) => setAuthorizedBy(e.target.value)}
                                    required
                                >
                                    <option value="">-- Select Authority --</option>
                                    <option value="MD">Managing Director (MD)</option>
                                    <option value="GM">General Manager (GM)</option>
                                </select>
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">Subject</label>
                                <input
                                    className="form-control"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    maxLength={40}
                                    required
                                />
                                <div className="text-muted small mt-1">
                                    {subject.length}/40 characters
                                </div>
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">Message</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">Attachment (optional)</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setAttachment(e.target.files[0])}
                                />
                            </div>

                            <div className="col-12 d-flex flex-column flex-sm-row gap-2 justify-content-end admin-form-actions">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => navigate("/service-record")}
                                >
                                    Cancel
                                </button>

                                <button className="btn btn-primary" type="submit">
                                    Create Thread
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateThread;
